// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    createExpensecategory,
    deleteExpensecategory,
    getExpensecategoryApi,
    updateExpensecategory,
} from '../../api/ExpensecategoryApi'; // Adjust the path as needed
import {
    getExpensecategorySuccess,
    getExpensecategoryFailure,
    createExpensecategorySuccess,
    createExpensecategoryFailure,
    updateExpensecategorySuccess,
    updateExpensecategoryFailure,
    deleteExpensecategorySuccess,
    deleteExpensecategoryFailure,
} from './actions';

// Saga to handle fetching Expensecategorys
function* fetchExpensecategorySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getExpensecategoryApi, action.payload);
        yield put(getExpensecategorySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getExpensecategoryFailure(errorMessage));
    }
}

// // Saga to handle creating a Expensecategory
function* createExpensecategorySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createExpensecategory, action.payload);
        yield put(createExpensecategorySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createExpensecategoryFailure(errorMessage));
    }
}

// // Saga to handle updating a Expensecategory
function* updateExpensecategorySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateExpensecategory, action.payload.data, action.payload.id);
        yield put(updateExpensecategorySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateExpensecategoryFailure(errorMessage));
    }
}

// // Saga to handle updating a Expensecategory
function* deleteExpensecategorySaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteExpensecategory, action.payload.id);
        yield put(deleteExpensecategorySuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteExpensecategoryFailure(errorMessage));
    }
}

export default function* ExpensecategorySaga() {
    yield takeEvery('GET_EXPENSECATEGORY_REQUEST', fetchExpensecategorySaga);
    yield takeEvery('CREATE_EXPENSECATEGORY_REQUEST', createExpensecategorySaga);
    yield takeEvery('UPDATE_EXPENSECATEGORY_REQUEST', updateExpensecategorySaga);
    yield takeEvery('DELETE_EXPENSECATEGORY_REQUEST', deleteExpensecategorySaga);
}
